// import userService from '@/services/user.service';
import customerService from "@/services/customer.service";
import { ACCOUNT_CHECKOUT } from "@/stores/defs";
import CustomerModel from "@/models/CustomerModel";
import { findIndex } from 'lodash';
var state = {
    customer: new CustomerModel({}),
    guestAddress: null,
    guestPhone: '',
    guestEmail: '',
    guestName: '',
    loggedIn: false,
    offers: [],
    addresses: [],
    selectedAddressId: null,
    selectedPaymentId: null,
    isNewAccount: false,
};
var getters = {
    getCustomer: function (state) {
        return state.customer;
    },
    getLoggedIn: function (state) {
        return state.loggedIn;
    },
    getLoyaltyPoints: function (state) {
        return customerService.getLoyaltyPoints(state.customer);
    },
    getOffers: function (state) {
        return state.offers;
    },
    getGuestAddress: function (state) {
        return state.guestAddress;
    },
    getGuestPhone: function (state) {
        return state.guestPhone;
    },
    getGuestEmail: function (state) {
        return state.guestEmail;
    },
    getGuestName: function (state) {
        return state.guestName;
    },
    getAddresses: function (state) {
        return state.addresses;
    },
    getSelectedAddressId: function (state) {
        return state.selectedAddressId;
    },
    getSelectedPaymentId: function (state) {
        return state.selectedPaymentId;
    },
    getIsNewAccount: function (state) {
        return state.isNewAccount;
    },
};
var actions = {
    addPayment: function (_a, paymentMethod) {
        var commit = _a.commit;
        commit("addPayment", paymentMethod);
    },
    setCustomer: function (_a, customer) {
        var commit = _a.commit;
        commit("setCustomer", customer);
    },
    setLoggedIn: function (_a, status) {
        var commit = _a.commit;
        commit("setLoggedIn", status);
    },
    addAddress: function (_a, address) {
        var commit = _a.commit;
        commit("addAddress", address);
    },
    deleteAddress: function (_a, apiReq) {
        var dispatch = _a.dispatch, commit = _a.commit, rootState = _a.rootState;
        commit("deleteAddress", apiReq.id);
    },
    editAddress: function (_a, address) {
        var commit = _a.commit;
        commit("editAddress", address);
    },
    deletePayment: function (_a, paymentId) {
        var dispatch = _a.dispatch, commit = _a.commit, rootState = _a.rootState;
        commit("deletePayment", paymentId);
        // if checkout payment method is deleted one, set to first one available or null
        if (rootState.accountCheckout.paymentMethod && rootState.accountCheckout.paymentMethod.id === paymentId) {
            var paymentMethod = null;
            if (state.customer.paymentAccounts.length) {
                paymentMethod = state.customer.paymentAccounts[0];
            }
            dispatch(ACCOUNT_CHECKOUT.SET_PAYMENT_METHOD, paymentMethod, { root: true });
        }
    },
    updateCustomer: function (_a, customerSubSet) {
        var commit = _a.commit;
        commit("updateCustomer", customerSubSet);
    },
    setOffers: function (_a, offers) {
        var commit = _a.commit;
        commit('setOffers', offers);
    },
    applyOffer: function (_a, offer) {
        var commit = _a.commit;
        commit('applyOffer', offer);
    },
    cancelOffer: function (_a, offer) {
        var commit = _a.commit;
        commit('cancelOffer', offer);
    },
    setGuestAddress: function (_a, guestAddress) {
        var commit = _a.commit;
        commit('setGuestAddress', guestAddress);
    },
    setGuestPhone: function (_a, guestPhone) {
        var commit = _a.commit;
        commit('setGuestPhone', guestPhone);
    },
    setGuestEmail: function (_a, guestEmail) {
        var commit = _a.commit;
        commit('setGuestEmail', guestEmail);
    },
    setGuestName: function (_a, guestName) {
        var commit = _a.commit;
        commit('setGuestName', guestName);
    },
    setSelectedAddressId: function (_a, selectedAddressId) {
        var commit = _a.commit;
        commit('setSelectedAddressId', selectedAddressId);
    },
    setSelectedPaymentId: function (_a, selectedPaymentId) {
        var commit = _a.commit;
        commit('setSelectedPaymentId', selectedPaymentId);
    },
    setIsNewAccount: function (_a, isNewAccount) {
        var commit = _a.commit;
        commit('setIsNewAccount', isNewAccount);
    },
};
var mutations = {
    addPayment: function (state, paymentMethod) {
        state.customer.paymentAccounts.push(paymentMethod);
    },
    setCustomer: function (state, customer) {
        state.customer = customer;
    },
    setLoggedIn: function (state, status) {
        state.loggedIn = status;
    },
    addAddress: function (state, address) {
        state.customer.addresses ? state.customer.addresses.push(address) : (state.customer.addresses = [address]);
        // TODO check for duplicates and replace
        state.addresses.push(address);
    },
    deleteAddress: function (state, addressId) {
        state.customer.addresses = state.customer.addresses.filter(function (address) {
            return address.id !== addressId;
        });
    },
    editAddress: function (state, address) {
        // update the previous address value
        for (var i = 0; i < state.customer.addresses.length; i++) {
            if (state.customer.addresses[i].id === address.id) {
                state.customer.addresses[i] = address;
                break;
            }
        }
    },
    deletePayment: function (state, paymentId) {
        state.customer.paymentAccounts = state.customer.paymentAccounts.filter(function (paymentAccount) { return paymentAccount.id !== paymentId; });
    },
    updateCustomer: function (state, customerSubSet) {
        for (var key in customerSubSet) {
            state.customer[key] = customerSubSet[key];
        }
    },
    setOffers: function (state, offers) {
        state.offers = offers;
    },
    applyOffer: function (state, offer) {
        var offerIndex = findIndex(state.offers, function (_offer) {
            if (offer.id === _offer.id) {
                return true;
            }
        });
        state.offers[offerIndex].redeem();
    },
    cancelOffer: function (state, offer) {
        var offerIndex = findIndex(state.offers, function (_offer) {
            if (offer.id === _offer.id) {
                return true;
            }
        });
        if (offerIndex === -1) {
            return;
        }
        state.offers[offerIndex].cancel();
    },
    setGuestAddress: function (state, guestAddress) {
        state.guestAddress = guestAddress;
    },
    setGuestPhone: function (state, guestPhone) {
        state.guestPhone = guestPhone;
    },
    setGuestEmail: function (state, guestEmail) {
        state.guestEmail = guestEmail;
    },
    setGuestName: function (state, guestName) {
        state.guestName = guestName;
    },
    setSelectedAddressId: function (state, selectedAddressId) {
        state.selectedAddressId = selectedAddressId;
    },
    setSelectedPaymentId: function (state, selectedPaymentId) {
        state.selectedPaymentId = selectedPaymentId;
    },
    setIsNewAccount: function (state, isNewAccount) {
        state.isNewAccount = isNewAccount;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/account.store.ts
// module id = null
// module chunks = 